import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, TextField, TextInput } from 'react-admin';
import IdInput from 'components/Filter/IdInput';
import List from 'components/List';
import IdField from 'components/IdField';

const BillingGroupManagementCompaniesFilters = [
  <IdInput />,
  <TextInput alwaysOn label="Name" source="search.name" />,
];

const BillingGroupManagementCompaniesList = () => (
  <List hasCreate exporter={false} filters={BillingGroupManagementCompaniesFilters}>
    <Datagrid bulkActionButtons={false}>
      <IdField />
      <TextField source="name" />
    </Datagrid>
  </List>
);

BillingGroupManagementCompaniesList.query = gql`
  query GET_LIST($input: BillingGroupManagementCompanyQueryInput) {
    _billingGroupManagementCompaniesMeta(input: $input) {
      count
    }
    billingGroupManagementCompanies(input: $input) {
      id
      name
    }
  }
`;

export default BillingGroupManagementCompaniesList;
